import { render, staticRenderFns } from "./Onboard.vue?vue&type=template&id=f8721ae4"
import script from "./Onboard.vue?vue&type=script&lang=js"
export * from "./Onboard.vue?vue&type=script&lang=js"
import style0 from "./Onboard.vue?vue&type=style&index=0&id=f8721ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports